import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { PortalProps } from "./PropsType";

export default function Portal(props: PortalProps) {
  const { children, mountNode = document.body } = props;
  const [visible, setVisible] = useState(!!props.visible);
  let defaultNode: HTMLDivElement | null = null;

  useEffect(() => {
    if (!props.mountNode && !defaultNode) {
      defaultNode = document.createElement("div");
      document.body.appendChild(defaultNode);
    }

    return () => {
      if (defaultNode) {
        document.body.removeChild(defaultNode);
      }
      defaultNode = null;
    };
  }, []);

  useEffect(() => {
    if (props.visible) {
      setVisible(!!props.visible);
    } else {
      // 为了消失时有动画，必须加一个定时器
      setTimeout(() => {
        setVisible(!!props.visible);
      }, 300);
    }
  }, [props.visible]);
  return visible ? ReactDOM.createPortal(children, mountNode) : null;
}
